// English translation

const en = {
  "hotel.calendar.select_date": "Select Date",
  "hotel.calendar.rates": "Plan Rates",
  "hotel.calendar.update_range": "Update Range",
  "hotel.calendar.update_start_date": "Start Date",
  "hotel.calendar.update_end_date": "End Date",
  "hotel.calendar.line": "Prices",
  "hotel.calendar.line.accommodation": "Accommodation",
  "hotel.calendar.line.price_list": "Price List",
  "hotel.calendar.line.unit_price": "Unit Price",
  "hotel.calendar.rate_plan": "Plan Rate",
  "hotel.calendar.company.operation_center": "Operation Center",
  "hotel.calendar.no_data_available": "No data available",
  "hotel.calendar.error_no_calendar":
    "Error no calendar available for the selected plan rate!",
  "hotel.calendar.update": "Update",
  "button.hotel.calendar.update": "Update",
};

export default en;
